import React from 'react';
import { useSelector } from 'react-redux';
import ComponentVariantEditor from 'layout/organisms/ComponentVariantEditor';
function VariantCreator() {
    const componentDetails = useSelector((state) => state.componentDetails);
    return React.createElement(ComponentVariantEditor, { type: "add", data: componentDetails });
}
export default VariantCreator;
